import React from 'react';
import { Typography } from './Typography';
import { Button } from './Button';
import { CheckIcon } from 'lucide-react';
import { t } from '../src/locales';
export const CTASection = () => {
  const benefits = t('cta.benefits');
  return <section className="w-full bg-[#004FFF] py-20 px-6 md:px-12" data-id="element-22">
      <div className="max-w-4xl mx-auto text-center" data-id="element-23">
        <h2 className="text-[50px] leading-[56px] text-white font-[200] mb-6" data-id="element-24">
          {t('cta.title')}
        </h2>
        <Typography variant="medium" className="text-white mb-8 max-w-2xl mx-auto" data-id="element-25">
          {t('cta.description')}
        </Typography>
        <div className="flex flex-wrap justify-center gap-4 mb-10" data-id="element-26">
          {benefits.map((benefit, index) => <div key={index} className="flex items-center bg-white/10 px-4 py-2 rounded-full" data-id="element-27">
              <CheckIcon size={16} className="text-white mr-2" data-id="element-28" />
              <Typography variant="small" className="text-white" data-id="element-29">
                {benefit}
              </Typography>
            </div>)}
        </div>
        <div className="inline-block bg-white rounded-full" data-id="element-30">
          <Button className="!bg-white !text-[#004FFF] hover:!bg-white/90" data-id="element-31">
            {t('cta.button')}
          </Button>
        </div>
        <Typography variant="small" className="text-white/80 mt-4" data-id="element-32">
          {t('cta.disclaimer')}
        </Typography>
      </div>
    </section>;
};